<template>
  <x-dialog
    :dialogState="showDialog"
    @toggleModal="toggleModal"
    :width="dialogWidth"
    :actions="{
      show: false
    }"
    :data-test-id="`${dataTestId}`"
  >
    <template slot="dialog_data">
      <div class="text-center">
        <h2 class="mt-2 font24">Your Trial will expire {{ remainingDays }}</h2>
        <x-button
          :color="primaryColor"
          @click="redirectToBilling"
          :buttonText="buttonText"
          class="mt-8 mb-3 white--text"
          :data-test-id="`${dataTestId}__upgrade-now-btn`"
        />
      </div>
    </template>
  </x-dialog>
</template>
<script>
export default {
  name: 'GlobalDialog',
  data() {
    return {
      showDialog: false,
      // no. of remaining days to display in alert box
      remainingDays: '',
      dialogWidth: '30%',
      buttonText: 'Upgrade Now',
      // alert will start when remaining days will be 3 or less
      maxRemainingDays: 3,
      dataTestId:'upgrade-plan-alert-dialog'
    };
  },
  computed: {
    primaryColor() {
      return this.$vuetify?.theme?.themes?.light?.primary;
    },
    trialEndedAt() {
      return this.subscriptions?.trialEndedAt;
    }
  },
  mounted() {
    this.trialExpireNotification();
  },
  methods: {
    /**
     * Toggle the modal
     */
    toggleModal() {
      this.showDialog = !this.showDialog;
    },
    // To redirect to billing screen
    redirectToBilling() {
      this.showDialog = false;
      if (this.$route.path !== '/configuration/billing/summary') {
        this.$router.replace('/configuration/billing/summary');
      }
    },
    // To calculate remaining days for trial expiry
    trialExpireNotification() {
      // To get no. of days remaining for trial expiry
      const remainingDays = this.calculateDateDifference({
        endDate: this.trialEndedAt
      });
      const isTrialPlan = this.isTrialPlan();
      // To start showing alert when remaining days will be less than 3 days
      if (
        isTrialPlan &&
        remainingDays >= 0 &&
        remainingDays <= this.maxRemainingDays
      ) {
        this.showDialog = true;
        // mainpulating wording to show according to remaining days, used today when remainingDays=1
        this.remainingDays = remainingDays
          ? `in ${remainingDays} day${remainingDays === 1 ? '' : 's'}`
          : 'today';
      }
    }
  }
};
</script>
